import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { OnboardingService } from '../../core/services/onboarding.service';
import { UserStateService } from '../../core/services/user-state.service';
import { LoggingService } from '../../core/services/logging.service';
import { AuthHeaderComponent } from '../../shared/ui/auth-layout/auth-header.component';
import { AuthFooterComponent } from '../../shared/ui/auth-layout/auth-footer.component';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-accept-terms',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AuthHeaderComponent,
    AuthFooterComponent,
    ToastModule,
    ButtonModule
  ],
  providers: [MessageService],
  templateUrl: './accept-terms.component.html',
  styleUrls: ['./accept-terms.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcceptTermsComponent implements OnInit {
  termsAccepted = false;
  loading = signal(false);
  currentTermsVersion = '2026-01-01';
  currentPrivacyVersion = '2026-01-01';

  constructor(
    private onboardingService: OnboardingService,
    private router: Router,
    private messageService: MessageService,
    private userStateService: UserStateService,
    private logger: LoggingService
  ) {}

  ngOnInit(): void {
    // Check if user has already accepted terms using state
    this.userStateService.getOrFetchState().subscribe({
      next: (status) => {
        if (status.termsAccepted) {
          // Already accepted, redirect to resolving to determine next step
          this.router.navigate(['/resolving']);
        }
      },
      error: (err) => {
        this.logger.error('Error checking onboarding status:', err);
      }
    });
  }

  onAccept(): void {
    if (!this.termsAccepted) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Acceptance Required',
        detail: 'Please check the box to accept the Terms of Service and Privacy Policy.'
      });
      return;
    }

    this.loading.set(true);

    this.onboardingService.acceptTerms(
      this.currentTermsVersion,
      this.currentPrivacyVersion
    ).subscribe({
      next: (response) => {
        // Update state immediately
        this.userStateService.updateState({ termsAccepted: true });

        this.messageService.add({
          severity: 'success',
          summary: 'Terms Accepted',
          detail: 'Thank you for accepting our Terms of Service and Privacy Policy.'
        });

        // Redirect to resolving page after short delay
        setTimeout(() => {
          this.router.navigate(['/resolving']);
        }, 1500);
      },
      error: (err) => {
        this.logger.error('Error accepting terms:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to accept terms. Please try again.'
        });
        this.loading.set(false);
      }
    });
  }
}
